import React from "react";
import { LanguageIcon } from "./SettingsIcons";

const LANGUAGES = [
  "English (US)",
  "English (UK)",
  "Spanish",
  "French",
  "German",
  "Hindi",
  "Japanese",
  "Chinese (Simplified)",
  "Portuguese",
  "Arabic",
];

const TIMEZONES = [
  "(GMT+05:30) Asia/Kolkata",
  "(GMT+00:00) UTC",
  "(GMT-05:00) America/New_York",
  "(GMT-08:00) America/Los_Angeles",
  "(GMT+01:00) Europe/London",
  "(GMT+09:00) Asia/Tokyo",
  "(GMT+08:00) Asia/Shanghai",
];

const DATE_FORMATS = [
  "DD/MM/YYYY",
  "MM/DD/YYYY",
  "YYYY-MM-DD",
  "DD-MMM-YYYY",
];

const SettingsLanguageTab = ({
  language,
  setLanguage,
  timezone,
  setTimezone,
  dateFormat,
  setDateFormat,
}) => {
  return (
    <div className="v2-settings-pg-card">
      <div className="v2-settings-pg-card__header">
        <div className="v2-settings-pg-card__icon-wrap" style={{ background: "#f5f3ff" }}>
          <LanguageIcon size={20} color="#8b5cf6" />
        </div>
        <div>
          <h3 className="v2-settings-pg-card__title">Language & Region</h3>
          <p className="v2-settings-pg-card__subtitle">
            Set your preferred language and regional settings
          </p>
        </div>
      </div>

      <div className="v2-settings-pg-card__body">
        {/* Language */}
        <div className="v2-settings-pg-field">
          <label className="v2-settings-pg-field__label">Language</label>
          <select
            className="v2-settings-pg-select"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          >
            {LANGUAGES.map((lang) => (
              <option key={lang} value={lang}>
                {lang}
              </option>
            ))}
          </select>
        </div>

        {/* Timezone */}
        <div className="v2-settings-pg-field">
          <label className="v2-settings-pg-field__label">Timezone</label>
          <select
            className="v2-settings-pg-select"
            value={timezone}
            onChange={(e) => setTimezone(e.target.value)}
          >
            {TIMEZONES.map((tz) => (
              <option key={tz} value={tz}>
                {tz}
              </option>
            ))}
          </select>
        </div>

        {/* Date Format */}
        <div className="v2-settings-pg-field">
          <label className="v2-settings-pg-field__label">Date Format</label>
          <select
            className="v2-settings-pg-select"
            value={dateFormat}
            onChange={(e) => setDateFormat(e.target.value)}
          >
            {DATE_FORMATS.map((fmt) => (
              <option key={fmt} value={fmt}>
                {fmt}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SettingsLanguageTab;
